import Artical from '@/assets/icons/articles.svg'
import Rediit from '@/assets/icons/rediit.svg'
import Twitter from '@/assets/icons/tweet.svg'
import Video from '@/assets/icons/video.svg'
import { SocialMediaType, SocialsType } from '@/services/coin/social'

interface SocialIconProps {
  type: SocialsType | SocialMediaType
  width?: number
  height?: number
  fill?: string
}

export default function SocialIcon({
  type,
  width = 16,
  height = 16,
  fill = 'var(--text-secondary)',
}: SocialIconProps) {
  switch (type) {
    case SocialsType.Reddit:
      return <Rediit fill={fill} width={width} height={height} />

    case SocialsType.Twitter:
      return <Twitter fill={fill} width={width} height={height} />

    case SocialMediaType.Video:
      return <Video fill={fill} width={width} height={height} />

    case SocialMediaType.Articles:
      return <Artical width={width} height={height} />

    default:
      return null
  }
}
